import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.self.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, toHandlers as _toHandlers, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import en from 'element-plus/dist/locale/en.mjs';
import i18n from '@/plugins/i18n';
import { watch, computed, onMounted, onBeforeUnmount, ref, shallowRef, defineAsyncComponent } from 'vue';
import { useStore } from 'vuex';
import { encrypt, isH5, isOverseasEnv } from '@/utils/api';
import { requestMemberPay, requestNbiRecharge } from '@/components/customAiChat/utils/memberBridge';
import { decryptRequest } from '@/utils/decryptRequest';
import { emitter } from './plugins/emitter';
import { ROADSHOW_URL_HOST } from '@/apis/host';
import { getStorageAuthInfo, cookie, storage } from '@/utils/storageOperateApi';
import { LOCAL_STORAGE_KEY, DECRYPT_KEY } from '@/constants';
import { isOpenedFromWorkBuddy, isWorkBuddyClient, OPEN_FROM_WORKBUDDY } from '@/utils/embedEntry';
import slsLogger from './utils/slsLogger';
import { Performance } from './utils/slsLogger/performance.js';
import router from './router';
import { useRoute } from 'vue-router';
import { isRouteInWhitelist, UPDATE_TYPE } from '@/utils/version/versionConfig.js';
import { useUploadCenter } from '@/common/hooks/useUploadCenter.js';
import { useDownloadCenter } from '@/common/hooks/useDownloadCenter.js';
import { useGlobalAudioPlaybackBridge } from '@/common/hooks/useGlobalAudioPlaybackBridge.js';
// TEMP_STREAM_DEBUG_OVERLAY: 临时调试浮窗，验证完成后删除（清理见 src/utils/tempStreamDebug/bus.js）
import TempStreamDebugOverlay from '@/utils/tempStreamDebug/StreamDebugOverlay.vue';
import { useIdleSessionTimeout } from '@/common/hooks/useIdleSessionTimeout.js';

import { h } from 'vue';
const ONE_HOUR_MS = 60 * 60 * 1000; // 1小时的毫秒数

export default /*@__PURE__*/Object.assign({
  name: 'App'
}, {
  __name: 'App',
  setup(__props) {
    const ToolTips = defineAsyncComponent(() => import('@/components/toolTips.vue'));
    const GlobalDialog = defineAsyncComponent(() => import('@/components/globalDialog/index.vue'));
    const GlobalGuideDialog = defineAsyncComponent(() => import('@/components/globalGuideDialog/index.vue'));
    const GlobalFeedbackDrawer = defineAsyncComponent(() => import('@/components/globalFeedbackDrawer/index.vue'));
    const PaySuccessDialog = defineAsyncComponent(() => import('@/components/customWebPay/paySuccessDialog/index.vue'));
    const AnalystDrawer = defineAsyncComponent(() => import('@/components/customAnalystDrawer/index.vue'));
    const CustomSecurityAuth = defineAsyncComponent(() => import('@/components/customSecurityAuth.vue'));
    const CustomSecurityFace = defineAsyncComponent(() => import('@/components/customSecurityFace.vue'));
    const CustomIframeDialog = defineAsyncComponent(() => import('@/components/customIframeDialog.vue'));
    const CustomWebPay = defineAsyncComponent(() => import('@/components/customWebPay/index.vue'));
    const CustomNbiRecharge = defineAsyncComponent(() => import('@/components/customNbiRecharge'));
    const NbiDetailDialog = defineAsyncComponent(() => import('@/components/customNbiRecharge/NbiDetailDialog.vue'));
    const StrongUpdateDialog = defineAsyncComponent(() => import('@/components/version/StrongUpdateDialog.vue'));
    const ExclusiveCustomer = defineAsyncComponent(() => import('@/components/exclusiveCustomer.vue'));
    const OverseasPay = defineAsyncComponent(() => import('@/components/overseasPay/payment.vue'));
    const ProgressCenter = defineAsyncComponent(() => import('@/components/progressCenter/ProgressCenter.vue'));
    const CustomAudioPlaybackController = defineAsyncComponent(() => import('@/components/customAudioPlaybackController'));
    const WorkBuddyHistoryNavigation = defineAsyncComponent(() => import('@/components/workBuddyHistoryNavigation.vue'));
    const uploadCenter = useUploadCenter();
    const downloadCenter = useDownloadCenter();

    // 合规受限用户空闲安全踢出（生产 30 分钟 / 测试 5 分钟）
    useIdleSessionTimeout();
    function onBeforeUnload(e) {
      if (uploadCenter.hasRunningTask() || downloadCenter.hasRunningTask()) {
        e.preventDefault();
      }
    }
    function onUnload() {
      uploadCenter.clearAll();
      downloadCenter.clearAll();
    }
    function onClearProgressCenter() {
      uploadCenter.clearAll();
      downloadCenter.clearAll();
    }
    const SEQUENCE = LOCAL_STORAGE_KEY.SEQUENCE;
    const cPerformance = Performance.record(router);
    cPerformance.created();

    // 版本检测现在由路由统一处理

    // 替换 locale 变量为响应式，跟随 vue-i18n
    const locale = computed(() => {
      switch (i18n.global.locale.value) {
        case 'en-US':
          return en;
        case 'zh-CN':
        default:
          return zhCn;
      }
    });
    const store = useStore();
    const route = useRoute();
    const shouldShowWorkBuddyHistoryNavigation = computed(() => isOpenedFromWorkBuddy(route.query) && route.name !== 'thirdpartyAiChatExternalIframe');
    const _useGlobalAudioPlayba = useGlobalAudioPlaybackBridge(store),
      globalAudioControllerRef = _useGlobalAudioPlayba.globalAudioControllerRef,
      globalAudioVisible = _useGlobalAudioPlayba.globalAudioVisible,
      globalAudioBarProps = _useGlobalAudioPlayba.globalAudioBarProps,
      onGlobalAudioBarClose = _useGlobalAudioPlayba.onGlobalAudioBarClose,
      onGlobalAudioBarManualClose = _useGlobalAudioPlayba.onGlobalAudioBarManualClose,
      onGlobalAudioPlaybackEnded = _useGlobalAudioPlayba.onGlobalAudioPlaybackEnded,
      onGlobalAudioTrackChange = _useGlobalAudioPlayba.onGlobalAudioTrackChange,
      onGlobalAudioPlay = _useGlobalAudioPlayba.onGlobalAudioPlay,
      onGlobalAudioPause = _useGlobalAudioPlayba.onGlobalAudioPause;
    const tooltips = computed(() => store.state.tooltips);
    const globalFeedbackDrawer = computed(() => store.state.globalFeedbackDrawer);
    const analystVisible = computed(() => store.state.analystVisible);
    const securityAuth = computed(() => store.state.securityAuth);
    const securityAuthType = computed(() => store.state.securityAuthType);
    const securityAuthContent = computed(() => store.state.securityAuthContent);
    const securityAuthCloseBtn = computed(() => store.state.securityAuthCloseBtn);
    const securityAuthSuccessBtn = computed(() => store.state.securityAuthSuccessBtn);
    const securityFace = computed(() => store.state.securityFace);
    const securityFaceType = computed(() => store.state.securityFaceType);
    const securityFaceCloseBtn = computed(() => store.state.securityFaceCloseBtn);
    const securityFaceSuccessBtn = computed(() => store.state.securityFaceSuccessBtn);
    const dialogIframe = computed(() => store.state.dialogIframe);
    // 关闭会员弹窗
    const handleDialogClosed = () => {
      dialogIframe.value.visible = false;
    };

    // Web支付弹窗
    const webPayDialog = computed(() => store.state.webPayDialog || {
      visible: false,
      props: {}
    });

    // 牛币充值全局壳层
    const nbiRechargeDialog = computed(() => store.state.nbiRechargeDialog || {
      visible: false,
      pendingPaySuccess: false,
      timestamp: 0
    });
    const nbiRechargeShellVisible = computed(() => {
      const d = nbiRechargeDialog.value;
      return !!(d.visible || d.pendingPaySuccess);
    });

    // 牛币明细全局弹窗（只读展示，独立于牛币充值流程；显隐由 Vuex nbiDetailDialog 驱动）
    const nbiDetailVisible = computed({
      get: () => {
        var _store$state$nbiDetai;
        return ((_store$state$nbiDetai = store.state.nbiDetailDialog) === null || _store$state$nbiDetai === void 0 ? void 0 : _store$state$nbiDetai.visible) || false;
      },
      set: v => store.commit('setNbiDetailDialog', {
        visible: v
      })
    });
    // 首次唤起后保持挂载：既让明细弹窗按需懒加载，又避免用 v-if 直接卸载而丢失关闭动画
    const nbiDetailShellVisible = ref(false);
    watch(() => {
      var _store$state$nbiDetai2;
      return (_store$state$nbiDetai2 = store.state.nbiDetailDialog) === null || _store$state$nbiDetai2 === void 0 ? void 0 : _store$state$nbiDetai2.visible;
    }, visible => {
      // 仅在打开时置为挂载；关闭时保持挂载，交由 el-dialog 走完关闭动画
      if (visible) {
        nbiDetailShellVisible.value = true;
      }
    });
    // 关闭支付弹窗
    const handleWebPayClosed = () => {
      store.commit('setWebPayDialog', {
        visible: false,
        props: {}
      });
    };
    // 支付成功回调
    const handleWebPaySuccess = function () {
      let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const payDialog = {
        ...webPayDialog.value
      };
      store.commit('globalDialog/addDialog', {
        component: shallowRef(PaySuccessDialog),
        customClass: 'pay-success-dialog',
        propsData: {
          width: '320px',
          showFooter: false,
          showClose: true,
          currentGoodsName: data.currentGoodsName || '',
          isRenewalFlag: data.isRenewal || false,
          headerRender: h => {
            return h('div', {
              class: 'flex flex-ac flex-sb w100-p'
            });
          }
        }
      });
      handleWebPayClosed();
      emitter.emit('member-pay-success', payDialog);
    };

    // ===== 会员/牛币付费弹窗：宿主代理 =====
    // 嵌入 iframe 且宿主声明支持时，不渲染本地会员/牛币弹窗，改为 postMessage 请求宿主处理；
    // 宿主超时未响应或回包 unsupported 时回退本地弹窗，保证行为可降级。
    const isEmbedded = window.self !== window.parent;
    const memberDelegate = computed(() => store.state.memberDelegate || {
      enabled: false,
      hostOrigin: ''
    });
    const shouldDelegateMember = computed(() => isEmbedded && memberDelegate.value.enabled);
    // 当前付费弹窗是否因宿主不可用而回退本地渲染
    const webPayFallbackLocal = ref(false);
    const nbiFallbackLocal = ref(false);
    watch(() => {
      var _store$state$webPayDi;
      return (_store$state$webPayDi = store.state.webPayDialog) === null || _store$state$webPayDi === void 0 ? void 0 : _store$state$webPayDi.visible;
    }, visible => {
      // 弹窗关闭：复位回退标记，便于下次重新走代理
      if (!visible) {
        webPayFallbackLocal.value = false;
        return;
      }
      // 未启用代理，或已回退本地：交给本地弹窗渲染，不转发
      if (!shouldDelegateMember.value || webPayFallbackLocal.value) {
        return;
      }
      const d = store.state.webPayDialog || {};
      const onSuccess = d.onSuccess;
      requestMemberPay({
        scene: d.scene,
        goodsDesc: d.goodsDesc,
        businessId: d.businessId,
        businessType: d.businessType
      }).then(status => {
        // 宿主声明不支持：回退本地弹窗
        if (status === 'unsupported') {
          webPayFallbackLocal.value = true;
          return;
        }
        store.commit('setWebPayDialog', {
          visible: false,
          props: {}
        });
        // 仅成功才刷新；取消/关闭不刷新
        if (status === 'success') {
          onSuccess === null || onSuccess === void 0 || onSuccess();
          emitter.emit('member-pay-success', d);
        }
      }).catch(() => {
        // 宿主超时未响应：回退本地弹窗
        webPayFallbackLocal.value = true;
      });
    });
    watch(() => {
      var _store$state$nbiRecha;
      return (_store$state$nbiRecha = store.state.nbiRechargeDialog) === null || _store$state$nbiRecha === void 0 ? void 0 : _store$state$nbiRecha.visible;
    }, visible => {
      if (!visible) {
        nbiFallbackLocal.value = false;
        return;
      }
      if (!shouldDelegateMember.value || nbiFallbackLocal.value) {
        return;
      }
      const d = store.state.nbiRechargeDialog || {};
      const onSuccess = d.onSuccess;
      requestNbiRecharge({
        scene: d.scene,
        needNbi: d.needNbi,
        balance: d.balance,
        businessId: d.businessId,
        businessType: d.businessType
      }).then(status => {
        if (status === 'unsupported') {
          nbiFallbackLocal.value = true;
          return;
        }
        store.commit('setNbiRechargeDialog', {
          visible: false
        });
        if (status === 'success') {
          onSuccess === null || onSuccess === void 0 || onSuccess();
          emitter.emit('nbi-recharge-success', d);
        }
      }).catch(() => {
        nbiFallbackLocal.value = true;
      });
    });
    watch(() => store.state.userInfo, v => {
      if (!v) return;
      if (v && window.__bl && typeof window.__bl.setConfig === 'function') {
        window.__bl.setConfig({
          uid: v.id
        });
      }
    }, {
      immediate: true
    });
    window._decryptRequest = decryptRequest;
    const iframeUrl = ref('');
    const timer = ref(null);

    // 版本检测相关
    const strongUpdateVisible = ref(false);
    const versionUpdateInfo = ref(null);
    const neverRemind = ref(false);
    const exclusiveCustomerVisible = ref(false);
    const exclusiveCustomerType = ref(undefined);

    // 版本更新处理方法（由 VersionChecker onUpdate 回调触发）
    const handleVersionUpdate = updateInfo => {
      var _window$routerVersion2;
      // 白名单页面由 VersionChecker 内部暂存处理
      if (isRouteInWhitelist(router.currentRoute.value)) {
        var _window$routerVersion;
        // 暂存到 checker，等路由切换后释放
        if ((_window$routerVersion = window.routerVersionCheck) !== null && _window$routerVersion !== void 0 && _window$routerVersion.getInstance()) {
          window.routerVersionCheck.getInstance().setPendingUpdate(updateInfo);
        }
        return;
      }
      versionUpdateInfo.value = updateInfo;

      // 读取 neverRemind 状态
      const checker = (_window$routerVersion2 = window.routerVersionCheck) === null || _window$routerVersion2 === void 0 ? void 0 : _window$routerVersion2.getInstance();
      const readState = checker === null || checker === void 0 ? void 0 : checker.getReadState();
      if (readState) {
        neverRemind.value = readState.isNeverRemind();
      }
      const updateType = updateInfo.updateType;
      if (updateType === UPDATE_TYPE.STRONG) {
        // 强提示 — 弹框弹出即已读
        strongUpdateVisible.value = true;
        checker === null || checker === void 0 || checker.markAsReadAndReport(updateInfo);
        emitter.emit('version-show-red-dot');
        slsLogger.console({
          action: 'version',
          message: '版本强提示弹框弹出',
          extra: {
            version: updateInfo.versionCode
          }
        });
      } else if (updateType === UPDATE_TYPE.MEDIUM) {
        // 中提示 — 通知 header 展示 popover，弹出即已读
        checker === null || checker === void 0 || checker.markAsReadAndReport(updateInfo);
        emitter.emit('version-medium-update', updateInfo);
        emitter.emit('version-show-red-dot');
        emitter.emit('version-silent-update', updateInfo);
        slsLogger.console({
          action: 'version',
          message: '版本中提示弹出',
          extra: {
            version: updateInfo.versionCode
          }
        });
      } else {
        emitter.emit('version-silent-update', updateInfo);
        slsLogger.console({
          action: 'version',
          message: '版本静默更新弹出',
          extra: {
            version: updateInfo.versionCode
          }
        });
      }
    };

    /** 点击"立即更新" — 强提示 */
    const handleVersionDoUpdate = () => {
      strongUpdateVisible.value = false;
      slsLogger.console({
        action: 'click',
        message: '用户点击版本更新立即更新按钮'
      });
      window.location.reload();
    };

    /** 强提示弹框关闭（叉号 → 确认弹框 → 我知道了） */
    const handleStrongClose = () => {
      strongUpdateVisible.value = false;
    };

    /** "不再提醒"勾选状态变化 */
    const handleNeverRemindChange = val => {
      var _window$routerVersion3;
      neverRemind.value = val;
      const checker = (_window$routerVersion3 = window.routerVersionCheck) === null || _window$routerVersion3 === void 0 ? void 0 : _window$routerVersion3.getInstance();
      const readState = checker === null || checker === void 0 ? void 0 : checker.getReadState();
      readState === null || readState === void 0 || readState.setNeverRemind(val);
    };

    // 注册版本更新处理器到路由
    const registerVersionUpdateHandler = () => {
      // 通过路由提供的接口注册处理器
      if (window.routerVersionCheck) {
        window.routerVersionCheck.setHandler(handleVersionUpdate);
      } else {
        // 如果路由还没准备好，通过事件监听作为备选方案
        emitter.on('version-update-detected', handleVersionUpdate);
      }
    };

    // 判定是否为分享类页面（需解除 .app 的 min-width:960px，避免移动端 iframe 被撑宽走 PC 预览布局）
    const isH5SharePage = computed(() => isH5 && route.name === 'aiChatShare' || route.name === 'aiChatIframe' || route.name === 'researchDocumentShare');
    const isRoadshowEmbedPage = computed(() => {
      return route.name === 'thirdpartyAiChatExternalIframe';
    });
    onMounted(() => {
      let iframe = null;
      // 注册版本更新
      registerVersionUpdateHandler();

      // 同步登录官网
      emitter.on('login-success', () => {
        const jmUserInfo = getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO);
        const webtoken = jmUserInfo.webtoken,
          uid = jmUserInfo.uid;
        const userInfo = encodeURIComponent(encrypt(JSON.stringify({
          token: webtoken,
          uid,
          overseasToken: cookie.get(LOCAL_STORAGE_KEY.OVERSEAS_TOKEN)
        }), DECRYPT_KEY));
        let options = {
          comein_channel: 'brm',
          orgId: jmUserInfo.organizationId,
          logo: store.state.orgLogo
        };
        options = encodeURIComponent(encrypt(JSON.stringify(options), DECRYPT_KEY));
        cookie.set(LOCAL_STORAGE_KEY.MAIN_TOKEN, webtoken, {
          domain: '.comein.cn'
        });
        cookie.set(LOCAL_STORAGE_KEY.MAIN_TOKEN, webtoken, {
          domain: '.finenter.ai'
        });
        const isWorkBuddyEntry = isWorkBuddyClient();
        iframeUrl.value = `${ROADSHOW_URL_HOST}/author?comein_channel=brm&userInfo=${userInfo}&options=${options}${isWorkBuddyEntry ? `&openFrom=${OPEN_FROM_WORKBUDDY}` : ''}`;
        if (isWorkBuddyEntry) {
          slsLogger.console({
            component: 'App',
            message: 'Portal登录同步-透传WorkBuddy来源',
            extra: {
              openFrom: OPEN_FROM_WORKBUDDY
            }
          });
        }
        iframe = document.createElement('iframe');
        iframe.src = iframeUrl.value;
        iframe.style.opacity = 0;
        iframe.style.position = 'absolute';
        iframe.style.zIndex = -1;
        iframe.style.top = '-100000px';
        document.body.appendChild(iframe);

        // 1分钟后自动关闭
        timer.value = setTimeout(() => {
          // iframe 可能已在 clearThirdPartyInfo 分支被移除，先判空
          if (iframe) {
            var _document$body;
            (_document$body = document.body) === null || _document$body === void 0 || _document$body.removeChild(iframe);
            iframe = null;
          }
          window.removeEventListener('message', handle);
          clearTimeout(timer.value);
        }, 1000 * 60 * 1);
      });
      emitter.on('login-error', () => {
        iframeUrl.value = '';
      });

      // 监听显示服务专员弹窗事件
      emitter.on('show-exclusive-customer', params => {
        exclusiveCustomerVisible.value = true;
        exclusiveCustomerType.value = params === null || params === void 0 ? void 0 : params.type;
      });
      const handle = e => {
        var _iframe, _e$data, _window$parent;
        if (e.data) {
          const event = e.data.event;
          switch (event) {
            case 'author_success':
              //合作页登录信息,判断本地是否存在用户登录信息 有则传入PC
              const cooperationInfo = storage.get(LOCAL_STORAGE_KEY.COOPERATION, true);
              // 登录同步 iframe 仅在 login-success 时创建、1 分钟后移除；
              // 其它页面（如 /activity/roadshow 内嵌 iframe）也可能发来 author_success，
              // 此时 iframe 可能为 null，需先判空避免访问 null.contentWindow 报错
              if ((_iframe = iframe) !== null && _iframe !== void 0 && _iframe.contentWindow && cooperationInfo && cooperationInfo.userInfo && cooperationInfo.userChannel) {
                const thirdPartyInfo = {
                  comein_channel: cooperationInfo.userChannel,
                  userInfo: encodeURIComponent(cooperationInfo.userInfo),
                  brmChannel: cooperationInfo.brmChannel
                };
                iframe.contentWindow.postMessage({
                  event: 'getThirdPartyInfo',
                  data: JSON.stringify(thirdPartyInfo)
                }, '*');
              }
              break;
            case 'clearThirdPartyInfo':
              // iframe 可能已被移除或从未创建，避免 removeChild(null) 抛错
              if (iframe) {
                document.body.removeChild(iframe);
                iframe = null;
              }
              window.removeEventListener('message', handle);
              clearTimeout(timer.value);
              break;
            case 'getCooperateInfo':
              const cooperateInfo = JSON.parse(((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.data) || '');
              if (cooperateInfo && cooperateInfo.comein_channel) {
                storage.set(LOCAL_STORAGE_KEY.COOPERATION, cooperateInfo, '', true);
              }
              (_window$parent = window.parent) === null || _window$parent === void 0 || _window$parent.postMessage({
                event: 'clearPCThirdPartyInfo'
              }, '*');
              break;
          }
        }
      };

      // 监听iframe的message事件
      window.addEventListener('message', handle, false);
      emitter.on('progress-center-clear-all', onClearProgressCenter);
      document.addEventListener('mousemove', registerSequenceEvent);
      window.addEventListener('beforeunload', onBeforeUnload);
      window.addEventListener('unload', onUnload);
    });
    onBeforeUnmount(() => {
      // 清理版本检测器
      if (window.routerVersionCheck) {
        window.routerVersionCheck.destroy();
      }

      // 清理事件监听器
      emitter.off('version-update-detected', handleVersionUpdate);
      emitter.off('login-success');
      emitter.off('login-error');
      emitter.off('show-exclusive-customer');
      emitter.off('progress-center-clear-all', onClearProgressCenter);
      document.removeEventListener('mousemove', registerSequenceEvent);
      window.removeEventListener('beforeunload', onBeforeUnload);
      window.removeEventListener('unload', onUnload);
    });

    /******* sequence *******/
    let lastUserActivity = Date.now(); // 记录上次用户活动的时间，初始化为0
    const registerSequenceEvent = () => {
      const now = Date.now();
      if (now - lastUserActivity >= ONE_HOUR_MS) {
        // 如果超过1小时没有用户活动，执行相应操作
        slsLogger.console({
          action: 'reset',
          message: '无用户活动超过1小时，sequence重置为0'
        });
        storage.set(SEQUENCE, 0, false, false, false);
      }
      lastUserActivity = now; // 更新上次用户活动时间
    };
    /******* sequence *******/

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: locale.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["app", {
            'share-page-h5': isH5SharePage.value,
            'embed-page': isRoadshowEmbedPage.value
          }])
        }, [shouldShowWorkBuddyHistoryNavigation.value ? (_openBlock(), _createBlock(_unref(WorkBuddyHistoryNavigation), {
          key: 0
        })) : _createCommentVNode("", true), _createVNode(_component_router_view), _createVNode(_Transition, {
          name: "tooltip"
        }, {
          default: _withCtx(() => [tooltips.value ? (_openBlock(), _createBlock(_unref(ToolTips), {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_unref(GlobalDialog)), _createVNode(_unref(GlobalGuideDialog)), globalFeedbackDrawer.value.visible ? (_openBlock(), _createBlock(_unref(GlobalFeedbackDrawer), _mergeProps({
          key: 1
        }, globalFeedbackDrawer.value.propsData, _toHandlers(globalFeedbackDrawer.value.listeners)), null, 16)) : _createCommentVNode("", true), analystVisible.value ? (_openBlock(), _createBlock(_unref(AnalystDrawer), {
          key: 2
        })) : _createCommentVNode("", true), securityAuth.value ? (_openBlock(), _createBlock(_unref(CustomSecurityAuth), {
          key: 3,
          "security-auth": securityAuth.value,
          "security-auth-type": securityAuthType.value,
          "security-auth-content": securityAuthContent.value,
          "security-auth-close-btn": securityAuthCloseBtn.value,
          "security-auth-success-btn": securityAuthSuccessBtn.value
        }, null, 8, ["security-auth", "security-auth-type", "security-auth-content", "security-auth-close-btn", "security-auth-success-btn"])) : _createCommentVNode("", true), securityFace.value ? (_openBlock(), _createBlock(_unref(CustomSecurityFace), {
          key: 4,
          "security-face": securityFace.value,
          "security-face-type": securityFaceType.value,
          "security-face-close-btn": securityFaceCloseBtn.value,
          "security-face-success-btn": securityFaceSuccessBtn.value
        }, null, 8, ["security-face", "security-face-type", "security-face-close-btn", "security-face-success-btn"])) : _createCommentVNode("", true), _createVNode(_unref(StrongUpdateDialog), {
          modelValue: strongUpdateVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => strongUpdateVisible.value = $event),
          "update-info": versionUpdateInfo.value,
          "never-remind": neverRemind.value,
          onUpdate: handleVersionDoUpdate,
          onClose: handleStrongClose,
          onNeverRemindChange: handleNeverRemindChange
        }, null, 8, ["modelValue", "update-info", "never-remind"]), _createVNode(_unref(CustomIframeDialog), {
          visible: dialogIframe.value.visible,
          "onUpdate:visible": _cache[1] || (_cache[1] = $event => dialogIframe.value.visible = $event),
          url: dialogIframe.value.url,
          "url-code": dialogIframe.value.urlCode,
          "show-qr-code": false,
          "close-on-click-modal": true,
          "is-show-side": dialogIframe.value.urlCode,
          "iframe-width": "420px",
          "iframe-height": "calc(100vh - 108px)",
          onClosed: handleDialogClosed
        }, null, 8, ["visible", "url", "url-code", "is-show-side"]), webPayDialog.value.visible && (!shouldDelegateMember.value || webPayFallbackLocal.value) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 5
        }, [!_unref(isOverseasEnv)() ? (_openBlock(), _createBlock(_unref(CustomWebPay), _mergeProps({
          key: 0
        }, webPayDialog.value.props, {
          key: webPayDialog.value.timestamp,
          "goods-desc": webPayDialog.value.goodsDesc,
          onClose: handleWebPayClosed,
          onPaySuccess: handleWebPaySuccess
        }), null, 16, ["goods-desc"])) : (_openBlock(), _createBlock(_unref(OverseasPay), _mergeProps({
          key: 1
        }, webPayDialog.value.props, {
          onClose: handleWebPayClosed
        }), null, 16))], 64)) : _createCommentVNode("", true), nbiRechargeShellVisible.value && (!shouldDelegateMember.value || nbiFallbackLocal.value) ? (_openBlock(), _createBlock(_unref(CustomNbiRecharge), {
          key: nbiRechargeDialog.value.timestamp
        })) : _createCommentVNode("", true), nbiDetailShellVisible.value ? (_openBlock(), _createBlock(_unref(NbiDetailDialog), {
          key: 7,
          visible: nbiDetailVisible.value,
          "onUpdate:visible": _cache[2] || (_cache[2] = $event => nbiDetailVisible.value = $event)
        }, null, 8, ["visible"])) : _createCommentVNode("", true), exclusiveCustomerVisible.value ? (_openBlock(), _createBlock(_unref(ExclusiveCustomer), {
          key: 8,
          modelValue: exclusiveCustomerVisible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => exclusiveCustomerVisible.value = $event),
          type: exclusiveCustomerType.value
        }, null, 8, ["modelValue", "type"])) : _createCommentVNode("", true), _createVNode(_unref(ProgressCenter), {
          kind: "upload"
        }), _createVNode(_unref(ProgressCenter), {
          kind: "download"
        }), _withDirectives(_createVNode(_unref(CustomAudioPlaybackController), _mergeProps({
          ref_key: "globalAudioControllerRef",
          ref: globalAudioControllerRef
        }, _unref(globalAudioBarProps), {
          onClose: _unref(onGlobalAudioBarClose),
          onManualClose: _unref(onGlobalAudioBarManualClose),
          onEnded: _unref(onGlobalAudioPlaybackEnded),
          onTrackChange: _unref(onGlobalAudioTrackChange),
          onPlay: _unref(onGlobalAudioPlay),
          onPause: _unref(onGlobalAudioPause)
        }), null, 16, ["onClose", "onManualClose", "onEnded", "onTrackChange", "onPlay", "onPause"]), [[_vShow, _unref(globalAudioVisible)]]), _createVNode(TempStreamDebugOverlay)], 2)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});